// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2019 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

:root {
  --theia-breadcrumbs-height: 22px;
}

.theia-breadcrumbs {
  height: var(--theia-breadcrumbs-height);
  position: relative;
  user-select: none;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  outline-style: none;
  list-style-type: none;
  overflow: hidden;
  padding: 0;
  margin: 0;
  background-color: var(--theia-breadcrumb-background);
}

.theia-breadcrumbs .ps__thumb-x {
  /* Same scrollbar height as in tab bar. */
  height: var(--theia-private-horizontal-tab-scrollbar-height) !important;
}

.theia-breadcrumbs .theia-breadcrumb-item {
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  white-space: nowrap;
  align-self: center;
  height: 100%;
  color: var(--theia-breadcrumb-foreground);
  outline: none;
  padding: 0 0.3rem 0 0.25rem;
}

.theia-breadcrumbs .theia-breadcrumb-item:hover {
  color: var(--theia-breadcrumb-focusForeground);
}

.theia-breadcrumbs .theia-breadcrumb-item:not(:last-of-type)::after {
  font-family: codicon;
  font-size: var(--theia-ui-font-size2);
  content: "\\eab6";
  display: flex;
  align-items: center;
  width: 0.8em;
  text-align: right;
  padding-left: 4px;
}

.theia-breadcrumbs .theia-breadcrumb-item::before {
  width: 16px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.theia-breadcrumbs .theia-breadcrumb-item:first-of-type::before {
  content: " ";
}

.theia-breadcrumb-item-haspopup:hover {
  background: var(--theia-accent-color3);
  cursor: pointer;
}

#theia-breadcrumbs-popups-overlay {
  height: 0px;
}

.theia-breadcrumbs-popup {
  position: fixed;
  width: 300px;
  max-height: 200px;
  z-index: 10000;
  padding: 0px;
  background: var(--theia-breadcrumbPicker-background);
  font-size: var(--theia-ui-font-size1);
  color: var(--theia-ui-font-color1);
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.theia-breadcrumbs-popup:focus {
  outline-width: 0;
  outline-style: none;
}

.theia-breadcrumbs-popup ul {
  display: flex;
  flex-direction: column;
  outline-style: none;
  list-style-type: none;
  padding-inline-start: 0px;
  margin: 0 0 0 4px;
}

.theia-breadcrumbs-popup ul li {
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  padding: 0.25rem 0.25rem 0.25rem 0.25rem;
}

.theia-breadcrumbs-popup ul li:hover {
  background: var(--theia-accent-color3);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/breadcrumbs.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;EACzC,uEAAuE;AACzE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,oDAAoD;EACpD,qCAAqC;EACrC,kCAAkC;EAClC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":["/********************************************************************************\n * Copyright (C) 2019 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n:root {\n  --theia-breadcrumbs-height: 22px;\n}\n\n.theia-breadcrumbs {\n  height: var(--theia-breadcrumbs-height);\n  position: relative;\n  user-select: none;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  outline-style: none;\n  list-style-type: none;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  background-color: var(--theia-breadcrumb-background);\n}\n\n.theia-breadcrumbs .ps__thumb-x {\n  /* Same scrollbar height as in tab bar. */\n  height: var(--theia-private-horizontal-tab-scrollbar-height) !important;\n}\n\n.theia-breadcrumbs .theia-breadcrumb-item {\n  display: flex;\n  align-items: center;\n  flex: 0 1 auto;\n  white-space: nowrap;\n  align-self: center;\n  height: 100%;\n  color: var(--theia-breadcrumb-foreground);\n  outline: none;\n  padding: 0 0.3rem 0 0.25rem;\n}\n\n.theia-breadcrumbs .theia-breadcrumb-item:hover {\n  color: var(--theia-breadcrumb-focusForeground);\n}\n\n.theia-breadcrumbs .theia-breadcrumb-item:not(:last-of-type)::after {\n  font-family: codicon;\n  font-size: var(--theia-ui-font-size2);\n  content: \"\\eab6\";\n  display: flex;\n  align-items: center;\n  width: 0.8em;\n  text-align: right;\n  padding-left: 4px;\n}\n\n.theia-breadcrumbs .theia-breadcrumb-item::before {\n  width: 16px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.theia-breadcrumbs .theia-breadcrumb-item:first-of-type::before {\n  content: \" \";\n}\n\n.theia-breadcrumb-item-haspopup:hover {\n  background: var(--theia-accent-color3);\n  cursor: pointer;\n}\n\n#theia-breadcrumbs-popups-overlay {\n  height: 0px;\n}\n\n.theia-breadcrumbs-popup {\n  position: fixed;\n  width: 300px;\n  max-height: 200px;\n  z-index: 10000;\n  padding: 0px;\n  background: var(--theia-breadcrumbPicker-background);\n  font-size: var(--theia-ui-font-size1);\n  color: var(--theia-ui-font-color1);\n  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n.theia-breadcrumbs-popup:focus {\n  outline-width: 0;\n  outline-style: none;\n}\n\n.theia-breadcrumbs-popup ul {\n  display: flex;\n  flex-direction: column;\n  outline-style: none;\n  list-style-type: none;\n  padding-inline-start: 0px;\n  margin: 0 0 0 4px;\n}\n\n.theia-breadcrumbs-popup ul li {\n  display: flex;\n  align-items: center;\n  flex: 0 1 auto;\n  white-space: nowrap;\n  cursor: pointer;\n  outline: none;\n  padding: 0.25rem 0.25rem 0.25rem 0.25rem;\n}\n\n.theia-breadcrumbs-popup ul li:hover {\n  background: var(--theia-accent-color3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
